import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import RecognizedIcon from 'dibs-vg/dist/react/recognized-ribbon';
import TopSellerIcon from 'dibs-vg/dist/react/diamond';
import VettedIcon from 'dibs-vg/dist/react/vetted-checkmark';

import PdpSharedDealerDistinction from './PdpSharedDealerDistinction';
import styles from './PdpSharedDealerDistinctions.scss';

const recognizedTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedTitle"
        defaultMessage="Recognized"
    />
);
const recognizedDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedDescription"
        defaultMessage="This designation is for sellers whose items consistently exemplify the best of 1stdibs."
    />
);

const topSellerTitle = (
    <FormattedMessage id="PdpSharedDealerDistinctions.topSellerTitle" defaultMessage="Top Seller" />
);
const topSellerDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.topSellerDescription"
        defaultMessage="This distinction represents the top 25% of sellers, based on sales."
    />
);

const vettedTitle = (
    <FormattedMessage id="PdpSharedDealerDistinctions.vettedTitle" defaultMessage="Vetted" />
);
const vettedDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedDescription"
        defaultMessage="This mark indicates this seller was approved by our experienced team of specialists."
    />
);

function PdpSharedDealerDistinctions({ seller, showDescriptions }) {
    const isRecognized = get(seller, 'isDistinguished');
    const isTopSeller = get(seller, 'isTopSeller');

    return (
        <div className={styles.container}>
            {isRecognized && (
                <PdpSharedDealerDistinction
                    icon={RecognizedIcon}
                    title={recognizedTitle}
                    description={showDescriptions && recognizedDescription}
                />
            )}
            {isTopSeller && (
                <PdpSharedDealerDistinction
                    icon={TopSellerIcon}
                    title={topSellerTitle}
                    description={showDescriptions && topSellerDescription}
                />
            )}
            <PdpSharedDealerDistinction
                icon={VettedIcon}
                title={vettedTitle}
                description={showDescriptions && vettedDescription}
            />
        </div>
    );
}

PdpSharedDealerDistinctions.defaultProps = {
    showDescriptions: false,
};

PdpSharedDealerDistinctions.propTypes = {
    seller: PropTypes.object.isRequired,
    showDescriptions: PropTypes.bool,
};

export default createFragmentContainer(PdpSharedDealerDistinctions, {
    seller: graphql`
        fragment PdpSharedDealerDistinctions_seller on Seller {
            isTopSeller
            isDistinguished
        }
    `,
});
